<template>
  <TableLayout>
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="业务数据" prop="businessData">
        <el-input type="text" placeholder="请输入业务数据" v-model="searchForm.businessData"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="searchForm.status" placeholder="请选择状态" clearable @change="search">
          <el-option value="ING" label="请求中"/>
          <el-option value="SUCCESS" label="成功"/>
          <el-option value="FAILED" label="超时"/>
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <template v-slot:table-wrap>
      <el-table
          v-loading="isWorking.search"
          :data="tableData.list"
          stripe
          @selection-change="handleSelectionChange"
      >
        <el-table-column prop="question" label="标题" min-width="180px"></el-table-column>
        <el-table-column prop="businessData" label="业务数据" min-width="120px"></el-table-column>
        <el-table-column prop="response" label="AI回答" min-width="120px">
          <template slot-scope="{row}">
            <el-button @click="$refs.aiAnswerDrawer.open('AI回答', row)">查看AI回答</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="mode" label="模型" min-width="120px"></el-table-column>
        <el-table-column prop="status" label="状态" min-width="100px">
          <template slot-scope="{row}">{{row.status | handleStatus}}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="140px"></el-table-column>
        <el-table-column prop="createUserInfo.realname" label="创建人" min-width="100px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="140px"></el-table-column>
        <el-table-column prop="updateUserInfo.realname" label="更新人" min-width="100px"></el-table-column>
      </el-table>
      <pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <AiAnswerDrawer ref="aiAnswerDrawer"/>
  </TableLayout>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import TableLayout from '@/layouts/TableLayout'
import BaseTable from '@/components/base/BaseTable'
import AiAnswerDrawer from '@/components/ai/AiAnswerDrawer'

export default {
  name: 'log',
  extends: BaseTable,
  components: { AiAnswerDrawer, Pagination, TableLayout },
  data () {
    return {
      searchForm: {
        businessData: '', // 业务数据
        status: '' // 状态
      }
    }
  },
  filters: {
    handleStatus (value) {
      if (value === 'ING') {
        return '请求中'
      }
      if (value === 'SUCCESS') {
        return '成功'
      }
      return '超时'
    },
    handleResponse (value) {
      return JSON.stringify(value, null, 2)
    }
  },
  created () {
    this.config({
      module: 'AI日志',
      api: '/system/aiRequestLog'
    })
    this.search()
  }
}
</script>

<style scoped lang="scss">

</style>
